
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infobytes",
      function () {
        return require("private-next-pages/infobytes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infobytes"])
      });
    }
  